import request from '@/utils/request'
import { GlobalStore } from '@/store/modules/global'

// 登录
export function logIn(data: any) {
  return request<{ result: boolean }>({
    url: '/api/user/login',
    method: 'post',
    data
  })
}

export function register(data: any) {
  return request({
    url: '/api/mng/user/v2/save',
    method: 'post',
    data
  })
}

// 上传
export function uploadFile(data: any) {
  return request({
    url: '/api/Upload/UploadFile',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    method: 'post',
    data
  })
}

// 查询用户关联的店铺
export function getAllStoreList() {
  return request({
    url: '/api/store/manage/list',
    method: 'get'
  })
}

// 获取所有国家
export function getAllCountry() {
  return request({
    url: '/api/country/manage/get-all',
    method: 'get'
  })
}

// 获取语言列表
export function getLanguageList() {
  return request({
    url: '/api/store/manage/languages',
    method: 'get'
  })
}

// 获取用户信息接口
export function loginInfo(tk: string) {
  return request({
    url: `/api/user/login/info?tk=${tk}`,
    method: 'get'
  })
}

export function transfer2erp(tk: string, platform: string) {
  return request({
    url: `/api/user/transfer2erp?tk=${tk}&platform=${platform}`,
    method: 'get'
  })
}

// 发送短信验证码
export function sendSMS(data: any) {
  return request({
    url: '/api/user/manage/verify/send',
    method: 'post',
    data
  })
}

// 查询审核类型
export function getAllTypesList() {
  const globalStore = GlobalStore()
  return request({
    url: '/api/compliance/manage/types',
    method: 'get',
    headers: {
      language: globalStore.language // 获取当前的语言
    }
  })
}

// 查询未处理的店铺
export function getUnhandledStores() {
  const globalStore = GlobalStore()
  return request({
    url: '/api/compliance/manage/getUnhandledStores',
    method: 'get',
    headers: {
      language: globalStore.language // 获取当前的语言
    }
  })
}

export function getShopifyAk(store: string, cid: string, cse: string) {
  return request({
    url: `/api/store/manage/get-access-token?url=${store}&cid=${cid}&cse=${cse}`,
    method: 'get'
  })
}



export function getShopifyAkV2(store: string, cid: string, cse: string, code: string) {
  return request({
    url: `/api/store/manage/v2/get-access-token?url=${store}&cid=${cid}&cse=${cse}&code=${code}`,
    method: 'get'
  })
}